/**
 * Identifies the current state of a charge made against a card
 */
export var ChargeStatus;
(function (ChargeStatus) {
    /**
     * Charge has been authorized for an amount that is frozen in the customer's account
     */
    ChargeStatus["Authorized"] = "authorized";
    /**
     * Authorization for the charge has expired
     */
    ChargeStatus["AuthorizationExpired"] = "authorization expired";
    /**
     * Charge has been refunded and is no longer active
     */
    ChargeStatus["Refunded"] = "refunded";
    /**
     * Charge authorization has ben released and this charge is no longer active
     */
    ChargeStatus["Released"] = "released";
    /**
     * Charge has been settled and is no longer active
     */
    ChargeStatus["Settled"] = "settled";
    /**
     * Charge settlement has failed and won't be retried
     */
    ChargeStatus["SettlementFailed"] = "settlement failed";
})(ChargeStatus || (ChargeStatus = {}));
